import React, { useState } from 'react';
import './index.css';
import SplashScreen from './components/SplashScreen';
import PaymentDialog from './components/PaymentDialog';
import HomePage from './pages/HomePage';
import StudentCodePage from './pages/StudentCodePage';
import StudentDetailsPage from './pages/StudentDetailsPage';
import StudentDetailPage from './pages/StudentDetailPage';
import StudentCodeSearchPage from './pages/StudentCodeSearchPage';
import { StudentDetail } from './types';

type AppScreen =
  | 'splash'
  | 'home'
  | 'studentCode'
  | 'studentCodeSearch'
  | 'studentDetails'
  | 'studentDetail';

const App: React.FC = () => {
  const [currentScreen, setCurrentScreen] = useState<AppScreen>('splash');
  const [selectedStudent, setSelectedStudent] = useState<StudentDetail | null>(
    null
  );
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);

  const handleSplashComplete = () => {
    setCurrentScreen('home');
  };

  const handleSelectStudentCode = () => {
    setCurrentScreen('studentCode');
  };

  const handleSelectStudentDetails = () => {
    setCurrentScreen('studentDetails');
  };

  const handleSelectStudentCodeSearch = () => {
    setCurrentScreen('studentCodeSearch');
  };

  const handleStudentFound = (student: StudentDetail) => {
    setSelectedStudent(student);
    setCurrentScreen('studentDetail');
  };

  const handleBackToHome = () => {
    setCurrentScreen('home');
    setSelectedStudent(null);
  };

  const handleProceedPayment = () => {
    setShowPaymentDialog(true);
  };

  const handleClosePaymentDialog = () => {
    setShowPaymentDialog(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {currentScreen === 'splash' && (
        <SplashScreen onComplete={handleSplashComplete} />
      )}

      {currentScreen === 'home' && (
        <HomePage
          onSelectStudentCode={handleSelectStudentCode}
          onSelectStudentDetails={handleSelectStudentDetails}
          onSelectStudentCodeSearch={handleSelectStudentCodeSearch}
        />
      )}

      {currentScreen === 'studentCode' && (
        <StudentCodePage
          onBack={handleBackToHome}
          onStudentFound={handleStudentFound}
        />
      )}

      {currentScreen === 'studentCodeSearch' && (
        <StudentCodeSearchPage
          onBack={handleBackToHome}
          onStudentFound={handleStudentFound}
        />
      )}

      {currentScreen === 'studentDetails' && (
        <StudentDetailsPage
          onBack={handleBackToHome}
          onStudentFound={handleStudentFound}
        />
      )}

      {currentScreen === 'studentDetail' && selectedStudent && (
        <StudentDetailPage
          student={selectedStudent}
          onBack={handleBackToHome}
          onProceedPayment={handleProceedPayment}
        />
      )}

      <PaymentDialog
        isOpen={showPaymentDialog}
        onClose={handleClosePaymentDialog}
      />
    </div>
  );
};

export default App;
